export enum Feature {
  Boards = 'boards',
}

export enum FeaturePageType {
  NoSites = 'new',
  OneSite = 'existing_one_site',
  MultipleSites = 'existing_multiple_sites',
}

export enum BoardsOnboardingStep {
  FloatingNotification = 'floating-notification',
}

export enum CommonFeatureAction {
  PopupShown = 'popup_shown',
  CloseButtonClick = 'close_click',
  ClickOutside = 'click_outside',
}

export type TOnboardingStep = BoardsOnboardingStep;

export type TOnboardingFeatureAction<T> = CommonFeatureAction | T;
